import React, { useState } from 'react';
import { useParams } from "react-router-dom";
import { MainNav } from '../../mainComponent/mainNav';
import { setHelperData } from "../../recoil/atom/setHelperData";
import { useRecoilState } from "recoil";
import { Wrapper } from '../../mainComponent/Wrapper';
import UserLinks from './partial/uselinks';
import { MainTabs } from '../../mainComponent/mainTabs';
import { TabPanel } from "../../common/tabpanel";
import CompletedAppointment from './partial/CompletedApt';
import CancelledAppointment from './partial/CancelledApt';
import IncompleteAppointment from './partial/IncompleteApt';
import DuePayments from './partial/DuePayments';
import InprogressAppointments from './partial/InprogressApt';

export default function PatientsClinicHistory() {
    const { doctorId } = useParams();
    const [helpersData, setHelpersData] = useRecoilState(setHelperData)
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Wrapper>
            <>
                <MainNav>
                    <ul className="clearfix">
                        <li className='float-none' style={{ fontSize: 'inherit' }}>Appointments History</li>
                    </ul>
                </MainNav>
                <div className='row'>
                    <div className='width_16'>
                        <div className='dash row'>
                            <UserLinks
                                doctorId={doctorId}
                                helperId={helpersData._id}
                                accessModule={helpersData.access_module}
                            />
                        </div>
                    </div>
                    <div className='width_84 common_box'>
                        <div>
                            <MainTabs
                                value={value}
                                onChange={handleChange}
                                label="Inprogress"
                                label1="InComplete"
                                label2="Due Payments"
                                label3="Cancelled"
                                label4="Completed"
                            >
                            </MainTabs>

                            <TabPanel value={value} index={0}>
                                <InprogressAppointments onChange={() => setValue(0)} doctorId={doctorId} />
                            </TabPanel>

                            <TabPanel value={value} index={1}>
                                <IncompleteAppointment doctorId={doctorId} />
                            </TabPanel>

                            <TabPanel value={value} index={2}>
                                <DuePayments onChange={() => setValue(0)} doctorId={doctorId} />
                            </TabPanel>

                            <TabPanel value={value} index={3}>
                                <CancelledAppointment doctorId={doctorId} />
                            </TabPanel>

                            <TabPanel value={value} index={4}>
                                <CompletedAppointment doctorId={doctorId} />
                            </TabPanel>
                        </div>
                    </div>
                </div>
            </>
        </Wrapper>
    )
}